import { IconWithText } from 'common/icon/icon-with-text.js';

interface IProps {
  freezingLevel: string;
}

export const DisplayForecastFreezingLevel = ({ freezingLevel }: IProps) => {
  // name="freezing-level-dark"
  return (
    <IconWithText icon="freezing-level" classes="IconWithText--responsive svg-fill-textSlate">
      <p className="u-textBold h4 u-mT-0 u-mB-0">Free air freezing level</p>
      <p className="u-textRegular u-mT-0 u-mB-0">{freezingLevel}</p>
    </IconWithText>
  );
};
